// Featured-tool banner entries — same discipline as newsData.js (see
// CLAUDE.md): when a tool worth promoting ships, add it here; remove entries
// that no longer deserve the spotlight. The homepage rotates through this
// list one per day.
//
// Shape: { id, name, tagline, cta, to (in-app path) | href (external),
//          roles } — roles is who the tool is FOR, which may be narrower
// than the route gate (never broader): a page can be technically open to
// everyone but only worth promoting to the people who'd use it.
export const featuredTools = [
  {
    // Promote to the people who submit these — the shop finds it via nav.
    id: "window-service-requests",
    name: "Window Service Requests",
    tagline:
      "Send window/door service issues to the shop and watch the progress — no more emailing the old form.",
    cta: "Submit a request",
    to: "/windowdoor/service-request",
    roles: ["Outside Sales", "Inside Sales", "Salesperson"],
  },
  {
    id: "interior-door-configurator",
    name: "Interior Door Configurator",
    tagline:
      "Real-time pricing on stock door packages — quote in minutes, not days.",
    cta: "Try it now",
    to: "/forms/new/rfq",
    roles: ["*"],
  },
  {
    // Kitchen designers' tool — same audience as the Cabinet nav section.
    id: "ai-render-enhancer",
    name: "AI Render Enhancer",
    tagline:
      "Turn a cabinet design render into a photorealistic image with AI.",
    cta: "Enhance a render",
    to: "/cabinet-quotes/design-render",
    roles: ["Cabinet Team"],
  },
  {
    // Audience matches the route gate — the people who manage branch TVs.
    id: "digital-signage",
    name: "Digital Signage",
    tagline:
      "Run the TVs at your branch from the website — upload media, build the playlist, and it's on screen in seconds.",
    cta: "Manage displays",
    to: "/signage",
    roles: ["Admin", "Executive Team", "General Manager"],
  },
  {
    // Audience matches the route gate — the safety team.
    id: "safety-overview",
    name: "Safety Overview",
    tagline:
      "Open concerns, extinguishers due, and overdue training for every branch — and upload and assign training videos right from your desk.",
    cta: "Open the overview",
    to: "/safety/overview",
    roles: ["Admin", "Safety Manager"],
  },
  {
    // Audience matches the route gate.
    id: "truth-chart",
    name: "Truth Chart 2.0",
    tagline:
      "Rep margins vs. company margins by product class and customer, straight from Bistrack.",
    cta: "Run a report",
    to: "/truthchart",
    roles: ["Admin", "Executive Team"],
  },
  {
    // Audience matches the route gate.
    id: "fleet",
    name: "Fleet",
    tagline:
      "Every forklift and truck in one place — live GPS, today's check-ins, and 90 days of searchable inspections.",
    cta: "Open Fleet",
    to: "/fleet",
    roles: ["Admin", "Fleet Manager"],
  },
];
